var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICN-Mange_search",
    "data-name": "ICN-Mange search",
    transform: "translate(-2688 -680)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1479",
    "data-name": "Rectangle 1479",
    width: 20,
    height: 20,
    rx: 3,
    transform: "translate(2688 680)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "manage_search_FILL0_wght400_GRAD0_opsz48",
    d: "M4,25V23.5H14V25Zm0-5.25v-1.5H9v1.5ZM4,14.5V13H9v1.5ZM22.95,25l-4-4a4.746,4.746,0,0,1-1.4.75A4.869,4.869,0,0,1,16,22a4.993,4.993,0,0,1-5-5,4.993,4.993,0,0,1,5-5,4.993,4.993,0,0,1,5,5,4.869,4.869,0,0,1-.25,1.55,4.746,4.746,0,0,1-.75,1.4l4,4ZM16,20.5A3.5,3.5,0,0,0,19.5,17,3.5,3.5,0,0,0,16,13.5,3.5,3.5,0,0,0,12.5,17,3.5,3.5,0,0,0,16,20.5Z",
    transform: "translate(2684 672.233)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhiteIcon);
export default __webpack_public_path__ + "static/media/Search-white-icon.d3916568bcd8cdf91d400f244b13fbe3.svg";
export { ForwardRef as ReactComponent };